export const languages = {
  JAPANESE: "jp",
  ENGLISH: "gp",
};

export const REDUX_STORE_NAME  = "A2P65X19P";

export const products = {
  SMS: "SMS",
  TWOFA: "TWOFA",
  SHORT_URL: "SHORT_URL",
  OTT: "OTT"
}

export const months = [
  {name: "January", value: 1},
  {name: "February", value: 2},
  {name: "March", value: 3},
  {name: "April", value: 4},
  {name: "May", value: 5},
  {name: "June", value: 6},
  {name: "July", value: 7},
  {name: "August", value: 8},
  {name: "September", value: 9},
  {name: "October", value: 10},
  {name: "November", value: 11},
  {name: "December", value: 12},
]

export const CSV_COLUMNS_MAX_CHARS = 30;